window.GetClubsAPI = (() => {
  const BASE_URL = 'https://api.getclubs.com/api';

  async function getJSON(path, options = {}) {
    const response = await fetch(`${BASE_URL}${path}`, options);
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }
    return response.json();
  }

  async function postJSON(path, body) {
    const response = await fetch(`${BASE_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }
    return response.json();
  }

  return {
    getSmcLeadTime() {
      return getJSON('/ship-lead-time');
    },

    getRentalLeadTime() {
      return getJSON('/rental-lead-time');
    },

    searchGolfCourses(query, { signal } = {}) {
      const params = new URLSearchParams({ query, limit: '5' });
      return getJSON(`/golf-courses/search?${params}`, { signal });
    },

    getSmcShippingRates(payload) {
      return postJSON('/smc-shipping', payload);
    },

    getRentalShippingRates(payload) {
      return postJSON('/rental-shipping', payload);
    },
  };
})();
